import { size } from 'constants/device';
import { APP_ROUTES } from 'constants/routes';

import React from 'react';
import Link from 'next/link';
import { Icons } from '@studenten/ui-components';
import { useWindowSize } from 'features/layout/hooks/useWindowSize';
import Picture from 'features/layout/components/Cards/common/Picture';
import Title from 'features/layout/components/Cards/common/Title';
import Location from 'features/layout/components/Cards/common/Location';
import { useFavorite } from 'hooks/useFavorite';
import placeholder from '../../../../../public/assets/placeholders/placeholder-2.svg';

import {
  Container,
  InfoContainer,
  PictureWrapper,
  VacationAndLocationContainer,
  Vacation,
} from './StyledCompanyCard';
import type { Props } from './types';

const getHeight = (isMobile: boolean, isHorizontal: boolean): string => {
  if (isHorizontal) return '100px';
  return isMobile ? '90px' : '146px';
};

const getLink = (type: string, slug: string): string => {
  if (type === 'Student society') return `${APP_ROUTES.STUDENT_SOCIETIES}/${slug}`;
  if (type === 'Student housing') return `${APP_ROUTES.STUDENT_HOUSING}/${slug}`;
  if (type === 'Healthcare') return `${APP_ROUTES.LIFESTYLE}${APP_ROUTES.HEALTH}/${slug}`;
  if (type === 'Gym and Sports') return `${APP_ROUTES.LIFESTYLE}${APP_ROUTES.SPORT}/${slug}`;
  return `${APP_ROUTES.COMPANIES}/${slug}`;
};

export const CompanyCard = ({
  hasVideo,
  title,
  photoURL,
  logoURL,
  industry,
  horizontal,
  city,
  objectID,
  slug,
  type,
}: Props) => {
  const [isFavorite, onFavoriteClick] = useFavorite('company', objectID);
  const { width } = useWindowSize();
  const isMobile = width < size.tablet;
  return (
    <Link href={getLink(type, slug)} passHref>
      <a>
        <Container horizontal={horizontal}>
          <PictureWrapper>
            <Picture
              src={photoURL || logoURL}
              height={getHeight(isMobile, horizontal)}
              width={horizontal ? '271px' : '100%'}
              fit="cover"
              alt="Company"
              fallBackSRC={placeholder}
              isFavorite={isFavorite}
              onFavoriteClick={onFavoriteClick}
              loading="lazy"
            />
            {hasVideo && <Icons.Play />}
          </PictureWrapper>
          <InfoContainer horizontal={horizontal}>
            <div>
              <Title maxLineCount={2}>{title}</Title>
            </div>
            <VacationAndLocationContainer>
              {industry && <Vacation>{industry}</Vacation>}
              {city && <Location name={city} />}
            </VacationAndLocationContainer>
          </InfoContainer>
        </Container>
      </a>
    </Link>
  );
};

CompanyCard.defaultProps = {
  horizontal: false,
};
